import { cn } from "@/utils/cn";

/** 긴급 슬롯 강조 — 싱글·기간(BULK) 공통 펄스 레이어 */
export function EmergencyHighlightPulse() {
  return (
    <div className="absolute inset-0 bg-transparent shadow-[0_0_10px_7px_rgba(239,68,68,0.8)] animate-pulse" />
  );
}

/** 긴급 아이콘 배지 — `EmergencyCode` / `EmergencyBulkRangeBar`에서 공통 사용 */
export function EmergencyBellBadge() {
  return (
    <div className="absolute border-3 border-red-500 rounded-full -top-2.5 -left-[9px] z-1 pointer-events-none">
      <div className="relative z-1 flex size-4.5 items-center justify-center rounded-full bg-white">
        <img
          src="/asset/icon/emergency.png"
          alt=""
          aria-hidden
          className="size-3 shrink-0 ml-[.5px] mb-[.5px]"
        />
      </div>
    </div>
  );
}

export default function EmergencyCode() {
  return (
    <div
      className={cn(
        "absolute left-1/2 top-1/2 z-10 size-7.5 pointer-events-none border-3 border-red-600 -translate-x-1/2 -translate-y-1/2 rounded-sm bg-transparent"
      )}
    >
      <EmergencyHighlightPulse />
      <EmergencyBellBadge />
    </div>
  );
}
